// Neutral brand mark. Renders the configured logo (VITE_LOGO_URL) when set,
// otherwise a rounded square carrying the organisation's initial letter. All
// colours come from theme tokens, so it follows light/dark automatically.

import React from "react";
import { brand } from "../src/brand";

interface Props {
  className?: string;
}

export default function BrandMark({ className = "w-8 h-8" }: Props) {
  if (brand.logoUrl) {
    return <img src={brand.logoUrl} alt={brand.orgName} className={`${className} object-contain`} />;
  }
  const initial = (brand.orgShortName || brand.orgName || "S").trim().charAt(0).toUpperCase();
  return (
    <span
      role="img"
      aria-label={brand.orgName}
      className={`${className} inline-grid place-items-center rounded-[22%] bg-primary-500 text-oncolor font-semibold select-none`}
      style={{ fontSize: "0.55em" }}
    >
      <span className="text-[1.6em] leading-none">{initial}</span>
    </span>
  );
}

// Mark + organisation name + app name, as shown at the top of the sign-in cards.
export function BrandLockup({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <BrandMark className="w-12 h-12 shrink-0" />
      <div className="min-w-0">
        <div className="text-xl font-semibold tracking-tight text-white leading-tight truncate">{brand.orgName}</div>
        <div className="font-mono text-[10px] text-slate-400 uppercase tracking-widest mt-1">{brand.appName}</div>
      </div>
    </div>
  );
}

// Small "Powered by …" credit. Renders nothing when VITE_POWERED_BY is empty.
export function PoweredBy({ className = "" }: { className?: string }) {
  if (!brand.poweredBy) return null;
  return (
    <div className={`text-[10px] text-slate-500 text-center ${className}`}>
      Powered by {brand.poweredBy}
    </div>
  );
}
